import styled from 'styled-components'

import { helpers } from 'styles'

export const Caption = styled.div`
	font-size: 14px;
	font-weight: 400;
	color: ${helpers.color.textMuted};
	text-align: right;
`
